import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/Subscriptions';
import { fetchSubscriptions, setForm } from '../../actions';
import { UNSUBSCRIBE_FORM } from '../../constants/forms';

type Props = {
    subscriptions: array,
    fetchSubscriptions: Function,
    setForm: Function,
};

export class Subscriptions extends Component<Props> {
    componentDidMount() {
        this.props.fetchSubscriptions(true, 1);
    }

    setUnsubscribeForm = (url, title, endDate) => {
        this.props.setForm(UNSUBSCRIBE_FORM, false, url, title, endDate);
    };

    render() {
        return (
            <Fragment>
                <section id="ipx-maincontent" className="user-accounts">
                    <Form
                        subscriptions={this.props.subscriptions}
                        fetchSubscriptions={this.props.fetchSubscriptions}
                        setUnsubscribeForm={this.setUnsubscribeForm}
                        lng={this.props.language}
                    />
                </section>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        subscriptions: state.subscriptions,
        language: state.auth.language,
    };
};

export default connect(
    mapStateToProps,
    {
        fetchSubscriptions,
        setForm,
    }
)(Subscriptions);



// WEBPACK FOOTER //
// ./src/containers/Forms/Subscriptions.js